import React from "react";
import heroBg from "../assets/hero-01.png";
import Services from "../components/Services";

export default function ServicesPage() {
  return (
    
    <div className="font-poppins">
      <section className="relative min-h-[300px] sm:min-h-[380px] lg:min-h-[450px] flex items-center justify-center text-white overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${heroBg})` }} />
        {/* ONLY CHANGE: overlay now uses #00C7EF at 55% opacity */}
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 199, 239, 0.55)" }} />
        <div className="relative text-center px-4 sm:px-8 lg:px-16 py-14 sm:py-20">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 " style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}>
            Our Services
          </h1>
          {/* <p className="text-base sm:text-xl lg:text-2xl font-semibold uppercase tracking-widest max-w-3xl mx-auto text-white leading-snug" style={{ textShadow: "1px 1px 6px rgba(0,0,0,0.9)" }}>
            We are your best HVAC service provider with excellent customer service & support
          </p> */}
        </div>
      </section>
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#f9f9f9" }}>
        <Services />
      </div>
    </div>
  );
}